import React from "react";
import "./ComingSoonNew.css";
import Comingsoon from "../../assets/comingsoon.png";

const ComingSoonNew = () => {
  return (
    <section className="csn-wrapper">
      <img
        src={Comingsoon}
        alt="Coming Soon Project"
        className="csn-bg-image"
      />

      <div className="csn-overlay"></div>

      <div className="csn-content">
        <h1 className="csn-title">
          A Landmark Vision Is Taking Shape
        </h1>

        <p className="csn-text">
          CM Group of Companies, Promoters & Developers—renowned for crafting
          exceptional villa communities, modern living spaces, and iconic
          developments across Pollachi—is preparing to unveil a completely new
          real-estate experience.
        </p>

        <p className="csn-subtext">
          A thoughtfully planned project designed for future growth, premium
          lifestyle, and high-value investment opportunities.
        </p>

        <div className="csn-badge">Your Next Investment Is Near</div>
      </div>
    </section>
  );
};

export default ComingSoonNew;
